import { Layout, Menu } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { CustIcon } from "../../Components/Svgs";
import "./SubDashboard.less";
const { Content } = Layout;

export const SubDashboardTemplate = ({ children, userData }) => {
  const location = useLocation();
  const [currentActiveTab, setCurrentActiveTab] = useState(undefined);
  const [subMenuOptions, setSubMenuOptions] = useState([]);
  const userTypeId = userData?.getUsersById?.user_access?.access_id;

  useEffect(() => {
    let masterTab = location.pathname.split("/")[1];
    let menuList = [];
    switch (masterTab) {
      case "employee":
        setCurrentActiveTab(location.pathname.split("/")[3]);
        menuList = [
          {
            key: "personal-details",
            title: "Personal Details",
            customIcon: "edit-alt",
            link: `/employee/${
              location.pathname.split("/")[2]
            }/personal-details`,
          },
          {
            key: "tasks",
            title: "Manage Tasks",
            customIcon: "tasks",
            link: `/employee/${location.pathname.split("/")[2]}/tasks`,
          },
          {
            key: "status",
            title: "Task Status",
            customIcon: "task_status",
            link: `/employee/${location.pathname.split("/")[2]}/status`,
          },
          {
            key: "vacation",
            title: "Vacation Days",
            customIcon: "vacation",
            link: `/employee/${location.pathname.split("/")[2]}/vacation`,
          },
        ];
        break;

      case "settings":
        setCurrentActiveTab(location.pathname.split("/")[2]);
        menuList = [];
        menuList.push({
          key: "profile",
          title: "My Profile",
          customIcon: "edit-alt",
          link: `/settings/profile`,
        });
        if (userTypeId === "1") {
          menuList.push({
            key: "business-information",
            title: "Business Information",
            customIcon: "briefcase",
            link: `/settings/business-information`,
          });
        }
        menuList.push({
          key: "change-password",
          title: "Change Password",
          customIcon: "lock",
          link: `/settings/change-password`,
        });
        if (userTypeId === "1") {
          menuList.push({
            key: "subscriptions",
            title: "My Subscriptions",
            customIcon: "currency",
            link: `/settings/subscriptions`,
          });
        }
        break;
      case "reports":
        setCurrentActiveTab(location.pathname.split("/")[2]);
        menuList = [];
        menuList.push({
          key: "location-performance",
          title: "Location Performance",
          customIcon: "ic_location_performance",
          link: `/reports/location-performance`,
        });
        menuList.push({
          key: "employee-performance",
          title: "Employee Performance",
          customIcon: "ic_employee_performance",
          link: `/reports/employee-performance`,
        });
        break;
      default:
        break;
    }
    setSubMenuOptions(menuList);
  }, [location, userTypeId]);

  return (
    <Content className="site-body-layout">
      <Layout className="subLayout h-100">
        <Layout.Sider className="leftSubLayout" width="240px">
          <Menu selectedKeys={[currentActiveTab]}>
            {subMenuOptions.map(({ key, title, customIcon, link }, index) => (
              <Menu.Item key={key} icon={<CustIcon type={customIcon} />}>
                <Link to={link}>{title}</Link>
              </Menu.Item>
            ))}
          </Menu>
        </Layout.Sider>
        <div className="rightSubLayout">{children}</div>
      </Layout>
    </Content>
  );
};
